import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'
import ResCavvPurchaseSample from '../samples/ResCavvPurchaseSample'
import { makeResCavvPurchaseRequest } from '../../../actions/threeDSTwoActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _3DS2, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const OBJECT = [ "resCavvPurchaseCC", "resCavvPurchaseCC", "$mpgTxn"]

const METHODS = {
    data_key: [".SetData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    order_id: [ ".SetOrderId(order_id);", ".setOrderId(order_id);", "'order_id'=>$order_id"],
    amount: [ ".SetAmount(amount);", ".setAmount(amount);", "'amount'=>$amount"],
    expiry_date: [ ".SetExpdate(expiry_date);", ".setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    ds_trans_id: [".SetDsTransId(\"DsTransId\");", ".setDsTransId(\"DsTransId\");", "'ds_trans_id' => $ds_trans_id"],
    final_auth: [".SetFinalAuth(\"true\");", ".setFinalAuth(\"true\");", "'final_auth' => ‘true’"],
    _3DS_version: [ ".SetThreeDSVersion(\"3DS_Version\");", ".setThreeDSVersion(\"3DS_Version\");", "'threeds_version'=>$threeds_version"],
    _3DS_server: [ ".SetThreeDSServerTransId(\"3DS_Server_Trans_Id\");", ".setThreeDSServerTransId(\"3DS_Server_Trans_Id\");", "'threeds_server_trans_id'=>$threeds_server_trans_id"],
    status_check: [ ".SetStatusCheck(status_check);", ".setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus($store_id,$api_token,$status,$mpgRequest);"],
    customer_ID: [ ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: [ ".SetDynamicDescriptor(dynamic_descriptor);", ".setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    CAVV: [ ".SetCavv(cavv);", ".setCavv(cavv);", "cavv=>$cavv"],
    commerce_indicator: [ ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt'=>$crypt"],
}

class Purchase3DSVault extends Component {
    state = {
        topRef: React.createRef()
    }

    generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    getOrderId() {
        const { order_id } = this.props;
        if(order_id === "none")
            return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
        else
            return `"${order_id}"`;
    }

    onResCavvPurchasePress() {
        const { resCavvPurchaseSuccess, loading, cavv } = this.props;
        if(loading || resCavvPurchaseSuccess || cavv === 'null' ) return;

        const { storeId, apiToken, expdate, amount } = this.props;

        const newOrderId = this.generateOrderId();
        this.props.updateOrderId({ featureId: _3DS2, orderId: newOrderId });

        const resCavvPurchaseRequest = { storeId, apiToken, order_id: newOrderId, expdate, amount, cavv };
        this.props.makeResCavvPurchaseRequest(resCavvPurchaseRequest);
    }

    renderBtn() {
        const { loading, resCavvPurchaseSuccess, cavv } = this.props;

        if(!(loading || resCavvPurchaseSuccess || cavv === 'null')) {
            return (
                <div style={{marginLeft: '20%'}} className={"requestButton"} onClick={() => this.onResCavvPurchasePress()}>
                    Res Cavv Purchase Request
                </div>
            );
        }
        else {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                     <div className="disabledButton">
                        Res Cavv Purchase Request
                     </div>
                     <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to get cavv by making 3DS Auth request.</i>
                </div>
            );
        }
    }

    renderInteractiveTool() {
        const { leftContents } = styles;

        return (
            <div className={leftContents}>
                <div ref={this.state.topRef} style={{ paddingLeft: '1vw', paddingRight: '2vw', marginBottom: '10%'}}>
                    <h3>Sample Purchase with Vault and 3-D Secure - resCavvPurchase</h3>
                    <ResCavvPurchaseSample />
                    {this.renderBtn()}
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <div ref={this.state.topRef}>
                    <span className="stepPageTitle"><b>Purchase with Vault and 3-D Secure</b></span>
                    
                    <div className="warning">
                        <p><b>WARNING: </b> Moneris strongly discourages the use of frames as part of a 3-D Secure implementation, and cannot guarantee their reliability when processing transactions in the production environment.</p>
                    </div>

                    <p><b>Purchase with Vault and 3-D Secure transaction object definition</b></p>
                    {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>ResCavvPurchaseCC resCavvPurchaseCC = new ResCavvPurchaseCC();</code>
                        case _JAVA:
                            return <code>ResCavvPurchaseCC resCavvPurchaseCC = new ResCavvPurchaseCC();</code>
                        case _PHP:
                            return <code>{"$txnArray = array(‘type’=>’res_cavv_purchase_cc', …);"}<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                        default:
                            return null
                        }
                    })()}

                    <p style={{ marginTop: '5vh' }}><b>HttpsPostRequest object for Purchase with Vault and 3-D Secure transaction</b></p>
                    {(() => {
                        switch(progLangId) {
                            case _DOTNET:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(resCavvPurchaseCC);</code>
                            case _JAVA:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(resCavvPurchaseCC);</code>
                            case _PHP:
                                return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                            default:
                                return null
                        }
                    })()}

                    <h3 style={{ marginTop: '10vh'}}>Purchase with Vault and 3-D Securetransaction request fields – Required</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>data key</td>
                            <td><i>String</i><br /><br />25-character alphanumeri</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.data_key[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>order ID</td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric<br /><br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.order_id[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>amount</td>
                            <td><i>String</i><br /><br /> 10-character decimal<br /><br />Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br /><br />Example: 1234567.89</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.amount[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>Cardholder Authentication Verification Value (CAVV)<br /><br /><p className="note"><b>NOTE: </b> For Apple Pay and Google Pay™ Cavv Purchase and Cavv Pre-Authorization transactions, CAVV field contains the decrypted cryptogram. For more, see Appendix A Definition of Request Fields.</p></td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.CAVV[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>electronic commerce indicator<br /><br /><p className="note"><b>NOTE: </b> For Apple Pay and Google Pay™ Cavv Purchase and Cavv Pre-Authorization transactions, the e-commerce indicator is a mandatory field containing the value received from the decrypted payload or a default value of 5. If you get a 2-character value (e.g.,. 05 or 07) from the payload, remove the initial 0 and just send us the 2nd character. For more, see Appendix A Definition of Request Fields.</p></td>
                            <td><i>String</i><br /><br /> 1-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.commerce_indicator[progLangId]}</code></td>
                        </tr>
                    </table>

                    <h3 style={{ marginTop: '7vh'}}>3-D Secure 2.2 -specific fields – Required</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>3DS Version <br /><p className="note"><b>NOTE: </b>Mandatory for ISV merchants only for transactions using 3-D Secure.</p></td>
                            <td><i>String</i><br /><br /> 10-character numeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS._3DS_version[progLangId]}</code><br/>
                            Required if sending a 3-D Secure version 2.0+ transaction<br /><br />Acceptable values:<br />2.0.0 = 3DS protocol 2.0.0<br />2.1.0 = 3DS protocol 2.1.0<br />2.2.0 = 3DS protocol 2.2.0<br />2.3.0 = 3DS protocol 2.3.0
                            </td>
                        </tr>
                        <tr>
                            <td>3DS server transaction ID<p className="note"><b>NOTE: </b>Mandatory for transactions using 3-D Secure version 2.0+ – obtained from the Cavv Lookup request or MPI 3DS Authentication request </p></td>
                            <td><i>String</i><br /><br />36-character numeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS._3DS_server[progLangId]}</code></td>
                        </tr>
                    </table>

                    <h3 style={{ marginTop: '10vh'}}>Purchase with Vault and 3-D Secure transaction request fields – Optional</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>customer ID</td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric<br /><p className="note"><strong>NOTE:</strong><br />Some special characters are not allowed:<br />{'< > $ % = ? ^ { } [ ] \\'}</p></td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.customer_ID[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>status check</td>                        
                            <td><i>Boolean</i><br />true/false</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.status_check[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>expiry date</td>
                            <td><i>String</i><br /><br />4-character alphanumeric<br /><br />YYMM</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.expiry_date[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>DS transaction ID</td>
                            <td><i>String</i><br /><br />36-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.ds_trans_id[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>final authorization<p className="note"><strong>NOTE:</strong><br />Applies to Mastercard transactions only</p></td>
                            <td><i>String</i><br /><br />true/false</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.final_auth[progLangId]}</code></td>
                        </tr>
                    </table>
                </div>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = state.threeDSTwo.main.config;
    const { loading, resCavvPurchaseSuccess, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { resCavvPurchaseSuccess, cavvLookupSuccess, selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeResCavvPurchaseRequest, updateOrderId})(Purchase3DSVault)
